/**
 * 需要想定確定 mutation hook。
 *
 * ConfirmDemandForecast RPC を呼んで全小売を一括確定する。
 */
import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  confirmDemandForecast,
  getDemandForecastDaily,
} from '@ebalance/proto/bffuser/v1/demand_forecast_service-DemandForecastService_connectquery'
import { getWorkflowCase } from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 需要想定を確定する mutation hook。
 * request は caller が `create(ConfirmDemandForecastRequestSchema, {...})` で組み立てて渡す。
 *
 * 確定成功時に GetWorkflowCase の cache を invalidate する (AC-DFC-007 の
 * `demand_step_confirmed` 派生値を最新化。invalidate しないと同一画面で確定した
 * 直後は `isDemandForecastReadonly` が古い cache から false を読み続け、backend
 * が FailedPrecondition で拒否するのに UI は編集可能なままになる)。
 *
 * GetDemandForecastDaily も invalidate する。確定前の page は確定時の根拠記録を
 * 持たないので、取り直さないと確定済み表示が読み出し失敗の案内 (AC-DFC-019) を
 * 出してしまう (AC-DFC-018)。
 */
export function useConfirmDemandForecast(
  caseId: string,
): InvalidatingMutationResultFor<typeof confirmDemandForecast> {
  return useInvalidatingMutation(confirmDemandForecast, [
    createConnectQueryKey({
      schema: getWorkflowCase,
      cardinality: 'finite',
      input: { id: caseId },
    }),
    createConnectQueryKey({
      schema: getDemandForecastDaily,
      cardinality: 'finite',
    }),
  ])
}
